<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-25 16:04:54
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\antiFake\fleeWarning\components\addOrEdit.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-dialog v-loading.fullscreen="loading" :append-to-body="true" title="处理" :visible="visible" width="450px"
    :destroy-on-close="true" :wrapper-closable="false" :show-close="false" :close-on-press-escape="false"
    :close-on-click-modal="false">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="处理方案" prop="handleWay">
        <el-select v-model="form.handleWay" placeholder="" clearable>
          <el-option v-for="dict in dictObj.handle_way" :key="dict.dictValue" :label="dict.dictLabel"
            :value="dict.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态" prop="handleStatus">
        <el-select v-model="form.handleStatus" placeholder="" clearable>
          <el-option v-for="dict in dictObj.handle_status" :key="dict.dictValue" :label="dict.dictLabel"
            :value="dict.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="handleRemark">
        <el-input v-model="form.handleRemark" type="textarea" maxlength="500" :rows="4"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  saveOrUpdateFleeWarning,
} from '@/api/antiFake/fleeWarning'
export default {
  name: 'AddOrEditFleeWarning',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    fleeWarningInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          handle_way: [],
          handle_status: []
        }
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      form: {
        handleWay: null,
        handleRemark: null,
        handleStatus: null,
        handleUser: null
      },
      rules: {
        handleWay: [
          {
            required: true,
            message: '请选择处理方案',
            trigger: ['change', 'blur']
          }
        ],
      }
    }
  },
  created() {
    if (this.fleeWarningInfo.id) {
      const { handleStatus, id } = this.fleeWarningInfo
      this.form.handleStatus = handleStatus
      this.form.handleUser = this.$store.state.user.userInfo.nickName
      this.$set(this.form, 'id', id)
      console.log(this.form,this.$store);
    }
  },
  // 方法集合
  methods: {
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        const params = JSON.parse(JSON.stringify(this.form));

        saveOrUpdateFleeWarning(params).then(() => {
          this.$emit('close')
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>
